//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/ScCollector.js";
import "../no/ScCollector.js";
let d=[[[0,"Angle01",1,0],[0,"Angle02",1,0],[0,"Angle03",1,0],[0,"Angle04",1,0],[0,"Angle05",1,0],[1,"BendFace",0,"ScCollector",0],[0,"NeutralFactor",1,0],[0,"NumberBends",1,0],[1,"StartEdge",0,"ScCollector",0]],[],[]];
SPLM.Tooling.PrebendBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.PrebendBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.PrebendBuilder.NumberBendsOption = Object.freeze({
    "Two" : "Two", "Three" : "Three", "Four" : "Four", "Five" : "Five", "Six" : "Six"});

export default SPLM;